module.exports = __webpack_public_path__ + "img/search-header-nav-below-toyota.23f33949.png";